import { type Route } from '#app/routes/mocra+/_sections+/+types/611.ts'
import { SECTIONS } from '#app/routes/mocra+/_sections+/section-data.ts'
import { SectionDetail } from '#app/routes/mocra+/_sections+/section-detail.tsx'

export const meta: Route.MetaFunction = () => [
	{ title: 'MoCRA — §611 Mandatory Recall Authority' },
]

export default function Section611() {
	return <SectionDetail section={SECTIONS['611']} />
}
